import { AuthLayout } from "../components/AuthLayout";
import { LoginForm } from "../components/LoginForm";
import { TrustBadges } from "../components/TrustBadges";

/**
 * Login page: the shared auth shell with the login form card and trust badges.
 */
export function Login() {
  return (
    <AuthLayout
      heading="Welcome back! 👋"
      subtitle="Sign in to continue to your account"
    >
      <LoginForm />
      <TrustBadges />
    </AuthLayout>
  );
}
